var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentVariant,{ref:"buildingVariant",tag:"component",attrs:{"data":_vm.data,"hash":_vm.hash,"order-no":_vm.orderNo}})
}
var staticRenderFns = []

export { render, staticRenderFns }